module.exports = __webpack_public_path__ + "img/close_black.a2730c00.svg";